var v = (d, n, r) => new Promise((a, s) => {
  var f = (l) => {
    try {
      o(r.next(l));
    } catch (e) {
      s(e);
    }
  }, u = (l) => {
    try {
      o(r.throw(l));
    } catch (e) {
      s(e);
    }
  }, o = (l) => l.done ? a(l.value) : Promise.resolve(l.value).then(f, u);
  o((r = r.apply(d, n)).next());
});
import { defineComponent as O, ref as p, watch as y, onMounted as I, onBeforeUnmount as M, createElementBlock as T, openBlock as g, createVNode as K, createElementVNode as w, Transition as b, withCtx as N, createCommentVNode as V, normalizeClass as W } from "vue";
import { a as A, e as D, f as L, i as U, W as S, _ as X } from "./exports-CVYl7bes.js";
const z = {
  key: 0,
  class: "math-loading-overlay"
}, F = /* @__PURE__ */ O({
  __name: "MathBlockNode",
  props: {
    node: {}
  },
  setup(d) {
    const n = d, r = p(null), a = p(null);
    let s = !1, f = 0, u = !1, o = null;
    const l = A();
    let e = null;
    const c = p(!0);
    function k() {
      return v(this, null, function* () {
        if (!n.node.content || !a.value || u)
          return;
        if (!s)
          try {
            !e && r.value && (e = l(r.value)), yield e == null ? void 0 : e.whenVisible;
          } catch (t) {
          }
        o && (o.abort(), o = null);
        const i = ++f, m = new AbortController();
        o = m, D(n.node.content, !0, {
          timeout: 3e3,
          waitTimeout: 2e3,
          maxRetries: 1,
          signal: m.signal
        }).then((t) => {
          u || i !== f || a.value && (a.value.innerHTML = t, s = !0, c.value = !1);
        }).catch((t) => v(null, null, function* () {
          if (u || i !== f || !a.value)
            return;
          const h = (t == null ? void 0 : t.code) || (t == null ? void 0 : t.name), x = h === "WORKER_INIT_ERROR" || (t == null ? void 0 : t.fallbackToRenderer), B = h === S || h === "WORKER_TIMEOUT", C = h === "KATEX_DISABLED";
          if (x || B) {
            const R = yield L();
            if (R) {
              try {
                const _ = R.renderToString(n.node.content, {
                  throwOnError: n.node.loading,
                  displayMode: !0
                });
                a.value.innerHTML = _, s = !0, c.value = !1, U(n.node.content, !0, _);
              } catch (_) {
              }
              return;
            }
          }
          if (C) {
            c.value = !1, a.value.textContent = n.node.raw;
            return;
          }
          s || (c.value = !0), n.node.loading || (c.value = !1, a.value.textContent = n.node.raw);
        }));
      });
    }
    return y(
      () => n.node.content,
      () => {
        k();
      }
    ), I(() => {
      k();
    }), M(() => {
      var i;
      u = !0, o && (o.abort(), o = null), (i = e == null ? void 0 : e.destroy) == null || i.call(e), e = null;
    }), (i, m) => (g(), T("div", {
      ref_key: "containerEl",
      ref: r,
      class: "math-block text-center overflow-x-auto relative min-h-[40px]"
    }, [
      K(b, { name: "math-fade" }, {
        default: N(() => [
          c.value ? (g(), T("div", z, [...m[0] || (m[0] = [
            w("div", { class: "math-loading-spinner" }, null, -1)
          ])])) : V("", !0)
        ]),
        _: 1
      }),
      w("div", {
        ref_key: "mathBlockElement",
        ref: a,
        class: W({ "math-rendering": c.value })
      }, null, 2)
    ], 512));
  }
}), E = /* @__PURE__ */ X(F, [["__scopeId", "data-v-dab27d4f"]]);
E.install = (d) => {
  d.component(E.__name, E);
};
export {
  E as default
};
